import { MutationTree } from 'vuex'
import { State } from './state'
import { ThreeMutationTypes as MutationTypes } from './mutation-types'

export type Mutations<S = State> = {
  [MutationTypes.THREE_RESET](state: S, payload: boolean): void
  [MutationTypes.SET_SCENE_LOADED](state: S, payload: boolean): void
  [MutationTypes.SET_CONTROLS_ENABLED](state: S, payload: boolean): void

  [MutationTypes.SET_BAG_LOADED](state: S, payload: boolean): void
  [MutationTypes.SET_ANIMATION_FINISHED](state: S, payload: boolean): void

  [MutationTypes.SET_TEX_DEFAULT_N](state: S, payload: string): void
  [MutationTypes.SET_TEX_BODY](state: S, payload: string): void
  [MutationTypes.SET_TEX_BODY_N](state: S, payload: string): void
}

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.THREE_RESET](state: State, payload: boolean) {
    state.isSceneLoaded = payload
    state.isControlsEnabled = payload
    state.isBagLoaded = payload
    state.isAnimationFinished = payload
    state.texDefaultN = null
    state.texBody = null
    state.texBodyN = null
  },
  [MutationTypes.SET_SCENE_LOADED](state: State, payload: boolean) { state.isSceneLoaded = payload; },
  [MutationTypes.SET_CONTROLS_ENABLED](state: State, payload: boolean) { state.isControlsEnabled = payload; },

  [MutationTypes.SET_BAG_LOADED](state: State, payload: boolean) { state.isBagLoaded = payload },
  [MutationTypes.SET_ANIMATION_FINISHED](state: State, payload: boolean) { state.isAnimationFinished = payload },

  [MutationTypes.SET_TEX_DEFAULT_N](state: State, payload: string) { state.texDefaultN = payload },
  [MutationTypes.SET_TEX_BODY](state: State, payload: string) { state.texBody = payload },
  [MutationTypes.SET_TEX_BODY_N](state: State, payload: string) { state.texBodyN = payload },
}
